const {
  REACT_APP_NPM_PACKAGE_VERSION,
  REACT_APP_BASE_URL,
  REACT_APP_AUTH_TOKEN
} = process.env

const baseUrl = REACT_APP_BASE_URL || 'http://localhost:8081'
const authToken = REACT_APP_AUTH_TOKEN

const config = {
  api: {
    baseUrl,
    token: authToken
  },
  version: REACT_APP_NPM_PACKAGE_VERSION
}

export default config
